import { Injectable } from '@angular/core'
import { PageMetaLinkService, SeoMetaService } from '@spartacus/storefront'
import { PageMetaService, PageRobotsMeta } from '@spartacus/core'
import { Meta, Title } from '@angular/platform-browser'
import { MbSeoMeta } from './page'
import { MbPageMetaLinkService } from './mb-page-meta-link.service'

@Injectable({
  providedIn: 'root'
})
export class MbSeoMetaService extends SeoMetaService {

  constructor (ngTitle: Title,
               ngMeta: Meta,
               pageMetaService: PageMetaService,
               pageMetaLinkService: PageMetaLinkService,
               private mbPageMetaLinkService: MbPageMetaLinkService) {
    super(ngTitle, ngMeta, pageMetaService, pageMetaLinkService)
  }

  set meta (meta: MbSeoMeta) {
    this.setKeywords(meta?.keywords ?? '')
    this.setOGDescription(meta?.ogDescription ?? '')
    this.setOGTitle(meta?.ogTitle ?? '')
    this.setOGType(meta?.ogType ?? '')
    this.setMetaTitle(meta?.metaTitle ?? '')
    this.setMetaDescription(meta?.description ?? '')
    this.setRobots(meta?.robots ?? [])
    this.setOGImage(meta?.ogImage ?? '')
    this.mbPageMetaLinkService.setHrefLang()
    super.meta = meta
  }

  setMetaTitle (title: string) {
    this.addTag({ name: 'title', content: title })
  }

  setMetaDescription (description: string) {
    this.addTag({ name: 'description', content: description })
  }

  setRobots (robots: PageRobotsMeta[]) {
    this.addTag({ name: 'robots', content: robots?.join(',') })
  }

  setKeywords (keywords: string) {
    this.addTag({ name: 'keywords', content: keywords })
  }

  setOGTitle (title: string) {
    this.addTag({ property: 'og:title', content: title })
  }

  setOGDescription (description: string) {
    this.addTag({ property: 'og:description', content: description })
  }

  setOGType (type: string) {
    this.addTag({ property: 'og:type', content: type })
  }

  setOGImage (imageUrl: string) {
    this.addTag({ property: 'og:image', content: imageUrl })
  }
}
